// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BaseItem, ColumnData } from './BaseItem';
import { QuickTableComparingType } from '@shared/utils/QuickTableMisc/QuickTableComparingType';
import { ColumnParams } from './ColumnParams';
import { IsHigh } from '@shared/commons/cache/Algorithm/HighLow/HighLowData';
import { VolumeFormatter } from '@shared/utils/Volume/VolumeFormatter';
import { DateTimeConvertor } from '@shared/utils/Time/DateTimeConvertor';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { StringUtils } from '@shared/utils/StringUtils';
import { TableTotalsVisibility } from './TableTotalsVisibility';
import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
import { ThemeManager } from '../misc/ThemeManager';
export class HighLowItem extends BaseItem {
    constructor(data) {
        super(null);
        this.Id = HighLowItem.StaticId;
        HighLowItem.StaticId++;
        this.Data = data;
    }
    getQuickTableCellForeground(column) {
        const colors = ThemeManager.colors;
        if (column === HighLowItem.SYMBOL_COL_INDEX) {
            return colors.tableSymbolForeground;
        }
        else if (column === HighLowItem.PRICE_COL_INDEX && !isNullOrUndefined(this.Data)) {
            return IsHigh(this.Data.EventType) ? colors.positiveColor : colors.negativeColor;
        }
        else {
            return super.getQuickTableCellForeground(column);
        }
    }
    GetItemId() {
        return this.ItemId;
    }
    getColumnValue(column) {
        var _a;
        switch (column) {
            case HighLowItem.SYMBOL_COL_INDEX:
                if (this.Data.InstrumentName != null) {
                    return this.Data.InstrumentName;
                }
                else {
                    return this.Instrument != null ? this.Instrument.DisplayName() : StringUtils.NOT_AVAILABLE;
                }
            case HighLowItem.CHANGE_COL_INDEX:
                return this.Data.AbsoluteChange;
            case HighLowItem.CHANGE_PR_COL_INDEX:
                return this.Data.InterestChange;
            case HighLowItem.PRICE_COL_INDEX:
                return this.Data.LastPrice;
            case HighLowItem.TIME_COL_INDEX:
                return this.Data.LastTradeDate;
            case HighLowItem.VOLUME_COL_INDEX:
                return this.Data.Volume;
            case HighLowItem.EXCHANGE_COL_INDEX:
                return (_a = this.Data.MarketDataExchange) !== null && _a !== void 0 ? _a : this.Data.TradingExchange;
        }
        return '';
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        let formattedValue = '';
        switch (column) {
            case HighLowItem.CHANGE_PR_COL_INDEX:
                formattedValue = isNaN(value) ? StringUtils.NOT_AVAILABLE : value.toFixed(2);
                break;
            case HighLowItem.TIME_COL_INDEX:
                formattedValue = DateTimeUtils.FormatToDateAndTime(DateTimeConvertor.ConvertUTCTimeToSelectedTimeZone(value));
                break;
            case HighLowItem.VOLUME_COL_INDEX:
                formattedValue = VolumeFormatter.getVolumeFormat(value);
                break;
            default:
                formattedValue = value === null || value === void 0 ? void 0 : value.toString();
        }
        return new ColumnData(value, formattedValue);
    }
    ColumnCount() {
        return HighLowItem.columnsParams.length;
    }
    GetColumnParams(i) {
        const par = HighLowItem.columnsParams[i];
        par.Hidden = par.DefaultHidden;
        return par;
    }
    GetDataType(columnIndex) {
        return HighLowItem.dataTypes[columnIndex];
    }
}
HighLowItem.StaticId = 0;
// Static Columns
HighLowItem.SYMBOL_COL_INDEX = 0;
HighLowItem.CHANGE_COL_INDEX = 1;
HighLowItem.CHANGE_PR_COL_INDEX = 2;
HighLowItem.PRICE_COL_INDEX = 3;
HighLowItem.TIME_COL_INDEX = 4;
HighLowItem.VOLUME_COL_INDEX = 5;
HighLowItem.EXCHANGE_COL_INDEX = 6;
HighLowItem.dataTypes = [
    QuickTableComparingType.String,
    QuickTableComparingType.Double,
    QuickTableComparingType.Double,
    QuickTableComparingType.Double,
    QuickTableComparingType.DateTime,
    QuickTableComparingType.Double,
    QuickTableComparingType.String
];
HighLowItem.columnsParams = [
    new ColumnParams('panel.HighLowPanel.Item.Symbol', 40, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.HighLowPanel.Item.Change', 40, QTAlignment.Right, TableTotalsVisibility.None, false, false),
    new ColumnParams('panel.HighLowPanel.Item.ChangePr', 40, QTAlignment.Right, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.HighLowPanel.Item.Price', 40, QTAlignment.Right, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.HighLowPanel.Item.Time', 40, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.HighLowPanel.Item.Volume', 40, QTAlignment.Right, TableTotalsVisibility.None, false, false),
    new ColumnParams('panel.HighLowPanel.Item.Exchange', 40, QTAlignment.Left, TableTotalsVisibility.None, false, false)
];
